import { ComponentProps, FC } from "react";
import * as _ from "lodash";
import { useSelector } from "react-redux";

import { Analytics } from "@ctra/components";
import { Enterprise, EnterpriseAppState, SectionEntity, SectionFilter } from "@ctra/api";

import { SectionContext } from "@analytics";
import { ChartFilterContext } from "@chart";
import { useFarm } from "@farms";

const { SectionPanel } = Analytics;

interface CustomPanelProps extends ComponentProps<typeof SectionPanel> {
  sectionID: SectionEntity["id"];
}

/**
 * Custom Panel component which allows wrapping of a Panel with a different tag other than Collapse
 * @param {string} sectionID
 * @param {React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | Iterable<React.ReactNode> | React.ReactPortal | boolean | null | undefined | (React.ReactElement<any, string | React.JSXElementConstructor<any>> & undefined) | (Iterable<React.ReactNode> & undefined) | (React.ReactPortal & undefined)} children
 * @param {Pick<CustomPanelProps & {children?: React.ReactNode | undefined}, "key" | "header" | "disabled" | "className" | "style" | "showArrow" | "prefixCls" | "forceRender" | "id" | "extra" | "collapsible">} rest
 * @return {JSX.Element}
 * @constructor
 */
export const CustomPanel: FC<CustomPanelProps> = ({ sectionID, children, ...rest }) => {
  const { farm } = useFarm();

  /**
   * Try to pick the filters already stored for the given section
   */
  const { isoDuration, timePeriod, ...filters } = useSelector<EnterpriseAppState, SectionFilter>((state) =>
    _.defaultTo(
      Enterprise.entities.getSectionFilters(state, {
        sectionID,
        farmID: farm?.id
      }),
      {}
    )
  );

  return (
    <ChartFilterContext.Provider isoDuration={isoDuration} filters={filters}>
      <SectionContext.Provider sectionID={sectionID}>
        <SectionPanel {...rest}>{children}</SectionPanel>
      </SectionContext.Provider>
    </ChartFilterContext.Provider>
  );
};
